import image1 from '@/assets/images/news/detail/20200330/1.webp';
import image2 from '@/assets/images/news/detail/20200330/2.webp';
import image3 from '@/assets/images/news/detail/20200330/3.webp';
import image4 from '@/assets/images/news/detail/20200330/4.webp';
import image5 from '@/assets/images/news/detail/20200330/5.webp';
import image6 from '@/assets/images/news/detail/20200330/6.webp';

export default {
  id: '20200330', //  模块 id
  title:
    '李强今天走访叮咚买菜、美团点评、欧莱雅，要求助推各类企业在沪逆势飞扬、做大做强！', // 标题
  origin: '2020-03-30 来源：上海发布', // 新闻来源
  editor: '编辑：吴文俊', // 编辑者
  content: [
    {
      type: 0,
      text:
        '今天下午（3月30日），市委书记李强走访我市部分中外企业，检查调研新冠肺炎疫情防控和复工复产复市情况，深入了解企业面临的机遇挑战，推动解决当前存在的问题困难，对企业在疫情期间积极履行社会责任、保障市场供应表示感谢。李强指出，要坚决贯彻落实习近平总书记重要讲话和指示批示精神，全力支持各类企业提振发展信心，严格落实防疫措施，加快恢复生产经营，奋力夺取疫情防控和实现经济社会发展目标双胜利。要进一步落实惠企政策、优化营商环境，推动企业把握新趋势新契机，打造更多新消费热点，形成更多新经济增长点，助推各类企业在沪逆势飞扬、做大做强。',
      isIndent: false,
    },
    {
      type: 0,
      text: '创新供给方式、强化科技支撑，最大限度恢复和释放被压抑的消费需求',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '李强首先来到上海壹佰米网络科技有限公司（叮咚买菜），详细听取公司创始人梁昌霖有关企业运营发展、参与疫情防控以及促进消费等情况介绍。疫情发生后，企业全力组织货源、保证品质、稳定价格，为用户持续提供健康便捷的买菜服务，还携手老字号和一线品牌启动系列促销活动和特色消费活动。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '李强说，在这次抗击疫情过程中，在线经济、到家经济、非接触经济展现出广阔发展前景，对于互联网创新企业、生活服务类企业是重大发展机遇。要抓紧抓早，积极谋划，主动出招，针对不同群体的消费特点，创新供给方式、强化科技支撑，保持线上新型消费热度不减，最大限度恢复和释放被压抑的消费需求。上海将全力营造更加良好的创新创业生态，让企业在抓机遇、求突破中实现更大发展。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '加快服务升级、技术升级，做好消费拉动、消费升级的大文章，全面提振消费信心，更好激发市场活力',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '美团点评集团充分发挥本地生活服务类互联网大平台综合优势，在疫情期间率先推出“无接触安心送”等专项行动，保障生活物资配送。李强与集团联合创始人穆荣均等管理团队成员深入交流，关切询问企业发展现状以及面临的困难，就企业参与城市安心消费、主题消费活动策划等作了具体了解。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text:
        '李强说，这次疫情带来生产方式、生活方式、消费方式的改变，很多企业根据新需求开拓了新业务，得到了新发展。要着眼长远，进一步增强化危为机的能力，加快服务升级、技术升级，做好消费拉动、消费升级的大文章，全面提振消费信心，更好激发市场活力。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '一如既往营造国际一流营商环境，全力支持企业在上海放心投资、安心经营、更好发展',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '欧莱雅（中国）有限公司在落实疫情防控主体责任的同时，加速恢复运营能力，积极推进线上线下融合的“非接触式云服务”。李强听取公司首席执行官费博瑞相关介绍，仔细了解新产品研发生产等情况。费博瑞表示，感谢疫情期间各级政府对公司疫情防控和复工复产的大力支持。我们将继续立足上海，积极拓展业务，持续激活消费复苏引擎。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text:
        '李强说，当前，中国国内疫情防控形势持续保持向稳向好态势。我们一手抓紧抓实抓细疫情防控各项工作，一手加快推进企业复工复产复市。欧莱雅等外资企业长期扎根上海，在参与和见证上海改革开放的同时自身取得长足发展。希望充分把握中国市场的巨大潜力和良好前景，更好发挥企业自身品牌效应，把更多新业务新模式新产品放在上海，进一步做大市场、做强影响。上海将一如既往营造国际一流营商环境，全力支持企业在上海放心投资、安心经营、更好发展。欢迎企业积极参加第三届中国国际进口博览会,继续共享发展机遇。',
      isIndent: false,
    },
    {
      type: 0,
      text: '市领导诸葛宇杰参加。',
      isIndent: false,
    },
  ],
};
